var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "w-100 d-flex flex-row px-2 pt-2" }, [
        _c(
          "div",
          { staticClass: "mr-2", staticStyle: { width: "33.33%" } },
          [
            _c("vSelect", {
              staticClass: "flex-grow-1",
              attrs: {
                options: _vm.boards,
                label: "name",
                clearable: false,
                disabled: !!_vm.state.timeTrackers.length
              },
              model: {
                value: _vm.selectedBoard,
                callback: function($$v) {
                  _vm.selectedBoard = $$v
                },
                expression: "selectedBoard"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mr-2", staticStyle: { width: "33.33%" } },
          [
            _c("vSelect", {
              staticClass: "flex-grow-1",
              attrs: {
                options: _vm.flows,
                label: "name",
                clearable: false,
                disabled: !!_vm.state.timeTrackers.length
              },
              model: {
                value: _vm.selectedFlow,
                callback: function($$v) {
                  _vm.selectedFlow = $$v
                },
                expression: "selectedFlow"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { width: "33.33%" } },
          [
            _c("vSelect", {
              staticClass: "flex-grow-1",
              attrs: {
                options: _vm.cards,
                label: "name",
                clearable: false,
                disabled: !!_vm.state.timeTrackers.length
              },
              model: {
                value: _vm.selectedCard,
                callback: function($$v) {
                  _vm.selectedCard = $$v
                },
                expression: "selectedCard"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      !_vm.state.timeTrackers.length
        ? _c("SelectTimeTracking", {
            staticClass: "m-2",
            attrs: {
              state: _vm.state,
              "selected-board": _vm.selectedBoard,
              "selected-flow": _vm.selectedFlow,
              "selected-card": _vm.selectedCard
            },
            on: {
              start: function($event) {
                return _vm.start($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.state.timeTrackers, function(tracker) {
        return _c("RunningTimeTracker", {
          key: tracker.id,
          staticClass: "m-2",
          attrs: { state: _vm.state, tracker: tracker },
          on: {
            stop: function($event) {
              return _vm.stop(tracker, $event)
            },
            updateComment: function($event) {
              return _vm.updateComment(tracker, $event)
            }
          }
        })
      }),
      _vm._v(" "),
      !_vm.state.timeTrackers.length
        ? _vm._l(_vm.recentlyStartedCards, function(card) {
            return _c("RecentTimeTracker", {
              key: card.card.id,
              staticClass: "m-2",
              attrs: {
                state: _vm.state,
                board: card.board,
                flow: card.flow,
                card: card.card,
                duration: card.duration
              },
              on: {
                select: function($event) {
                  return _vm.selectRecentCard(card)
                },
                start: function($event) {
                  return _vm.startRecentCard(card)
                }
              }
            })
          })
        : _vm._e(),
      _vm._v(" "),
      _c("TrackerOverrunModal", {
        ref: "overrunModal",
        attrs: { state: _vm.state }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }